var AdsenseManager = function(containerHandle){
	
	return {
	'pubId' : 'ca-pub-3435502459646059',
	'defaultBlock' : '300X100',
	'adslist' : {
					'RESP_LINKS_768':{
						'width':'728',
						'height':'15',
						'ad_slot': 5494156549,
						'ad_format' : 'link'
					},
					'RESP_LINKS_468':{
						'width':'468',
						'height':'15',
						'ad_slot': 5494156549,
						'ad_format' : 'link'
					},
					'RESP_LINKS_200':{
						'width':'200',
						'height':'90',
						'ad_slot': 5494156549,
						'ad_format' : 'link'
					},
					'300X100':{
						'width':300,
						'height':100,
						'ad_slot': 2878767342,
						'ad_format' : 'auto'
					},
					'300X250':{
						'width':300,
						'height':250,
						'ad_slot': 1825064147,
						'ad_format' : 'auto'
					},
					'336X280':{
						'width': 336,
						'height': 280,
						'ad_slot': 5971834542,
						'ad_format' : 'auto'
					},
					'300X600':{
						'width':300,
						'height':600,
						'ad_slot': 1402034143,
						'ad_format' : 'auto'
					},
					'468X60':{
						'width':468,
						'height':60,
						'ad_slot': 4355500543,
						'ad_format' : 'auto'
					},
					'728X90':{
						'width':728,
						'height':90,
						'ad_slot': 3301797349,
						'ad_format' : 'auto'
					},
					'970X90':{
						'width': 970,
						'height': 90,
						'ad_slot': 7448567745,
						'ad_format' : 'auto',
					},
					'970X250':{
						'width': 970,
						'height': 250,
						'ad_slot': 2739166541,
						'ad_format' : 'auto',
					}
	},
	'createAndRenderAdBlock' : function(){
			var adKey;
			if($(window).width() >= 970 && !this.mobilecheck()){
				adKey = $(containerHandle).attr("data-desktop");
			} else{
				adKey = $(containerHandle).attr("data-mobile");
			} 

			//returning if doesnt need to be displayed on this device
			if(adKey == 'hidden'){
				return false;
			}

			//creating a default block if nothing is provided.
			if(adKey.trim()==''){
				adKey = this.defaultBlock;
			}

			var insBlock = document.createElement("ins");
			insBlock.setAttribute("class","adsbygoogle");
			insBlock.setAttribute("style","display:inline-block;margin:auto;");
			insBlock.setAttribute("data-ad-client",this.pubId);
			insBlock.setAttribute("data-ad-slot",this.adslist[adKey].ad_slot);
			insBlock.setAttribute("data-ad-format",this.adslist[adKey].ad_format);
			if(this.adslist[adKey].width!=''){
				insBlock.style.width = this.adslist[adKey].width+"px";
			} 
			if(this.adslist[adKey].height!=''){
				insBlock.style.height = this.adslist[adKey].height+"px";
			} 

			containerHandle.appendChild(insBlock);
			this.initiateAd();

	},
	'initiateAd' : function(){
		(adsbygoogle = window.adsbygoogle || []).push({});
	},
	'mobilecheck' : function() {
	  var check = false;
	  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
	  return check;
	}
	}; // return
	
};
$(document).ready(function(){

	var adBlocks = document.getElementsByClassName("adblock-google");
	for(var idx=0;idx<adBlocks.length;idx++){
		var adCode = new AdsenseManager(adBlocks[idx]);
		adCode.createAndRenderAdBlock();
	}

});

